export default __webpack_public_path__ + "static/media/Headshot-4.ef540397.jpg";